import React, { useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  CUSTOMER_CARE_OPTION,
  CUSTOMER_CARE_PHONE,
} from "constant/patientPortalConstants";
import ContactForm from "./ContactForm";

interface ContactDrawerProps {
  open: boolean;
  onClose: () => void;
}

const ContactDrawer = ({ open, onClose }: ContactDrawerProps) => {
  // Like the Benefits Summary message dialog: a sent message is cleared once the
  // drawer has closed, so the next one starts blank. An unsent draft is kept.
  const [formKey, setFormKey] = useState(0);
  const sent = useRef(false);
  const clearIfSent = () => {
    if (!sent.current) return;
    sent.current = false;
    setFormKey((key) => key + 1);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      keepMounted
      slotProps={{
        paper: { sx: { width: { xs: "100%", sm: 440 } } },
        transition: { onExited: clearIfSent },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: 2, pl: 3 }}
      >
        <Typography variant="h6" component="h2">
          Contact us
        </Typography>
        <IconButton onClick={onClose} aria-label="Close contact form" sx={{ width: 44, height: 44 }}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Divider />
      <Box sx={{ p: 3, overflowY: "auto" }}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Questions about appointments, scheduling, or anything else? Send us a
          note. For something urgent, call {CUSTOMER_CARE_PHONE},{" "}
          {CUSTOMER_CARE_OPTION}.
        </Typography>
        <ContactForm
          key={formKey}
          open={open}
          onClose={onClose}
          onSent={() => {
            sent.current = true;
          }}
        />
      </Box>
    </Drawer>
  );
};

export default ContactDrawer;
